import { inject, injectable } from "../../other/injection";
import { MessageBusService } from "../../other/messageBus/MessageBusService";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable("transient")
export class TestBridgeStore {
    @observable.shallow
    public feedPresets: RedDeer.Contracts.Dtos.Feed.FeedPresetDto[] = [];

    @observable public testEnumValue =
        RedDeer.Contracts.Enums.DataItemType.Security;

    constructor(
        @inject(MessageBusService) private messageBusService: MessageBusService
    ) {
        makeObservable(this);
    }

    @action
    public onComponentCreate = () => {
        const query: RedDeer.Contracts.Queries.Feed.GetPresetsQuery = {
            MessageType: "Queries.Feed.GetPresetsQuery"
        };
        return this.messageBusService.asyncSubscribe({
            request: query,
            description: "subscribing to feed presets",
            callback: (
                response: RedDeer.Contracts.Queries.Feed.GetPresetsResponse
            ) => {
                runInAction(() => {
                    this.feedPresets = response.Items ?? this.feedPresets;
                });
            }
        });
    };
}
